var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurancePayment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4195 15.3232L11.1866 16.3048C11.9107 16.4944 12.6442 16.047 12.8096 15.3162C12.965 14.6189 12.5408 13.9255 11.8476 13.7475L6.62192 12.4023L0.999999 15.9153L3.10059 19.2769L4.61136 18.3329L13.3318 20.6808L18.938 17.1776C19.5567 16.791 19.7459 15.9762 19.3585 15.3562C18.9719 14.7375 18.1558 14.5491 17.5371 14.9357L14.2094 17.015L12.1387 16.1955",
    stroke: "#020303",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.966 10.3989L10.9766 9.66609C10.2127 9.62438 9.45933 9.43325 8.92576 9.19042C8.73523 9.1035 8.64059 8.88697 8.69865 8.68583L8.89479 8.00586C8.96641 7.75611 9.2408 7.63061 9.47902 7.73431C10.0082 7.96538 10.6635 8.15133 11.3726 8.16177C12.1085 8.17212 12.6612 7.93042 12.6684 7.41871C12.675 6.95743 12.255 6.67675 11.2357 6.38759C9.78183 5.96759 8.74279 5.31613 8.76127 4.03102C8.77783 2.8706 9.63891 1.99705 11.1145 1.78119L11.1252 1.04806C11.1283 0.8121 11.3224 0.623516 11.5582 0.626976L11.989 0.633035C12.2252 0.636598 12.4134 0.830578 12.41 1.06643L12.4009 1.7246C13.1074 1.76306 13.6205 1.89152 14.0269 2.04073C14.2352 2.11718 14.3463 2.34426 14.2854 2.55783L14.1051 3.18671C14.0354 3.42964 13.7732 3.559 13.5384 3.4664C13.1646 3.31876 12.6348 3.16297 11.9434 3.15333C11.0701 3.14053 10.8153 3.49877 10.8109 3.82341C10.805 4.2223 11.325 4.50441 12.4553 4.87014C14.0705 5.37995 14.7343 6.06346 14.7172 7.27349C14.7013 8.38395 13.8635 9.37034 12.2627 9.59697L12.2511 10.4173C12.2476 10.6532 12.0536 10.8418 11.8177 10.8383L11.387 10.8323C11.1511 10.8288 10.9625 10.6347 10.966 10.3989Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurancePayment);
export default __webpack_public_path__ + "static/media/insurance-payment.f22bf7fd63aee81c6c1085c57b7c2e5b.svg";
export { ForwardRef as ReactComponent };